(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Show Video Popup
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-carousel-cell-mini-video-thumbnail', function () {
          const obj = jQuery(this);
          const inst = obj.attr('inst');
          var bs_vid = document.getElementById("video-popup-modal-"+inst);
          if ($('.video-popup-modal').is(':hidden')) {
            $('.video-popup-modal').slideDown('slow', function () {
              $('#header-search').val('').focus();
              bs_vid.play();
              $('body').css({'overflow':'hidden'});
            });
          }
          return false;
        });

        $(document).on('click', '.js-video-popup-modal-close', function () {
          const obj = jQuery(this);
          const inst = obj.attr('inst');
          var bs_vid = document.getElementById("video-popup-modal-"+inst);
          bs_vid.pause();
          bs_vid.currentTime = 0;
          $('.video-popup-modal').slideUp('slow');
          $('body').removeAttr('style');
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();


              if ($('body').hasClass('navbar-active')) { //mobile menu active
                $('body').addClass('scroll-locked');
              }else{
                $('body').removeClass('scroll-locked');
              }


            });
          } else {
            $('.js-section-site-search').slideUp('slow');

            if ($('body').hasClass('navbar-active')) { //mobile menu active
              $('body').addClass('scroll-locked');
            }else{
              $('body').removeClass('scroll-locked');
            }
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });


        //////////////////////////////////////////////////////////////
        // SEARCH FILTER SCRIPT
        //////////////////////////////////////////////////////////////

        $(document).on('tap click','.js-bs_search_filter_item',function(e){
          e.preventDefault();
          const obj = $(this);
          const val = obj.attr('typ');
          const inputField = document.getElementById("bs_search_filter_input");
          inputField.value = val;
          obj.closest('form').submit();
        })

        const dropdownElement = $('.js-cmb-mob-toggler');
        $(document).click(function(event) {
          if (dropdownElement.is(':visible')) {
            if (!$.contains(dropdownElement[0], event.target)) {
              dropdownElement.next().slideUp('fast');
              setTimeout(function(){
                  dropdownElement.removeClass('show');
              },400);
            }else{
              dropdownElement.next().slideToggle('fast');
              setTimeout(function(){
                if ($('.cmb-mob-dropdown').is(':visible')) {
                  dropdownElement.addClass('show');
                } else {
                  dropdownElement.removeClass('show');
                }
              },400);
            }
          }
        });

        jQuery(document).on('mouseenter','.js-cmb-mob-dropdown li', function(e){
          const obj = jQuery(this);
          obj.find('a').addClass('highlighted');
          obj.siblings().find('a').removeClass('highlighted');
        })


        //////////////////////////////////////////////////////////////
        // Scrolled nav
        //////////////////////////////////////////////////////////////
        bs_adjust_scroll_nav();
        $(window).scroll(function (event) {
          const viewport_width = window.innerWidth;
          if(!$('body').hasClass('navbar-active')){
            bs_adjust_scroll_nav();
          }
        });


        function bs_adjust_scroll_nav(){
          var scroll = $(window).scrollTop();
          if(scroll > 566){
            $('.page-nav-scrolled').slideDown('fast');
          }else{
            $('.page-nav-scrolled').slideUp('fast');
          }
        }




        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.js-navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          setTimeout(function(){
            $('.navbar').toggleClass('trans');
          },600)
          $('body').toggleClass('navbar-active');

          setTimeout(function(){
            if ($('body').hasClass('navbar-active')) {
              $('body').addClass('scroll-locked');
            }else{
              $('body').removeClass('scroll-locked');
            }
          },200);
        });

        $('.js-navbar-toggler-search').on('click', function () {
          $('.js-section-site-search').slideUp('slow');
          setTimeout(function(){
            $(this).toggleClass('active');
            $('.navbar').toggleClass('active');
            setTimeout(function(){
              $('.navbar').toggleClass('trans');
            },600)
            $('body').toggleClass('navbar-active scroll-locked');
          }, 600)
        });

        $('.js-header-search-input').on('keypress', function(event) {
          const obj = $(this);
          if (event.keyCode === 13) {
            event.preventDefault();
            obj.closest('form.search-form').submit();
          }
        });


        $('.js-navbar-nav li.dropdown').hover(function() {
          const obj = $(this);
          const viewportWidth = $(window).width();
          if( viewportWidth > 1199){
            obj.find('.js-dropdown-toggle').addClass('show');
            obj.find('.dropdown-menu').stop(true, true).delay(200).fadeIn(200);
          }
        }, function() {
          const obj = $(this);
          const viewportWidth = $(window).width();
          if( viewportWidth > 1199){
            obj.find('.js-dropdown-toggle').removeClass('show');
            obj.find('.dropdown-menu').stop(true, true).delay(200).fadeOut(200);
          }
        });

        $(window).resize(function(){
          const viewportWidth = $(window).width();
          if( viewportWidth < 1200){
            $('.dropdown-menu').removeAttr('style');
          }else{
            $('.navbar').removeClass('active trans');
          }
        });


        //////////////////////////////////////////////////////////////
        // TEAM MEMBER MODAL
        //////////////////////////////////////////////////////////////
        $(document).on('click tap','.js-section-flexi-team-slider-block .carousel-cell .carousel-cell-icon',function(e){
            const obj = $(this);
            const mdl = $('.team_member_modal');
            const htm = obj.next().html();
            //const htm = obj.find('.carousel-cell-json').html();
            $('.team_member_modal_container').html(htm);
            mdl.slideDown('200ms');
            $('body').addClass('scroll-locked');
        })

        $(document).on('click tap','.js-team_member_col_content_close',function(e){
            $(this).closest('.team_member_modal').slideUp('200ms');
            $('body').removeClass('scroll-locked');
        })



        $(document).on('click tap','.js-teamarch-row-col-content.team',function(e){
          const obj = $(this);
          const mdl = $('.team_member_modal');
          const htm = obj.find('.carousel-cell-json').html();
          $('.team_member_modal_container').html(htm);
          mdl.slideDown('200ms');
          $('body').addClass('scroll-locked');
        })





        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
          adjustNavPositionTop();
        });


        /////////////////////////////////////////////////////////////////////////////////////
        // NOTIFICATION - ALERT
        /////////////////////////////////////////////////////////////////////////////////////
        jQuery(document).on('click tap','.js-section-page-header-notification-close',function(){
          const obj = $(this);
          const cookieSlug = obj.closest('.section-page-header-notification').attr('data-slug');
          obj.closest('.section-page-header-notification').slideUp('fast');
          setCookie(cookieSlug, true , 7);
          setTimeout(function(){
            adjustNavPositionTop();
          },400)
        })

        adjustNavPositionTop();

        function adjustNavPositionTop(){

          const viewportWidth = jQuery(window).width();
          let excpd = (viewportWidth < 1200) ? 20: 35;
          
          if ( jQuery('.section-page-header-notification').is(':visible') || jQuery('#wpadminbar').is(':visible') ) {
            if ( jQuery('.section-page-header-notification').is(':visible')){
              excpd = 35;
            }
            let notif = false;
            let notif_hgt = 0;
            let notif_top = 0;
            if( jQuery('.section-page-header-notification').is(':visible') ){
              notif = jQuery('.section-page-header-notification');
              notif_hgt = notif.outerHeight();
              notif_top = notif.offset().top;
            }else{
              if(viewportWidth > 1200){

              }
            }
            let tlbr = false;
            let tlbr_hgt = 0;
            if( jQuery('#wpadminbar').is(':visible') ){
              tlbr = jQuery('#wpadminbar');
              tlbr_hgt = tlbr.outerHeight();

            }
            const header_offset = tlbr_hgt + notif_hgt + excpd;
            jQuery('header').css({'paddingTop':header_offset+'px'});
          }else{
            jQuery('header').css({'paddingTop':excpd+'px'});
            //jQuery('header').removeAttr('style');
          }

          setTimeout(function(){
            jQuery('header').show();
          },100);
        }
        
        jQuery(document).ready(function() {
          const notif_obj = jQuery('.section-page-header-notification');
          const notif_slug = notif_obj.attr('data-slug');
          if(notif_obj.length > 0){
            if( !getCookie(notif_slug) ){
              notif_obj.slideDown('fast');
              setTimeout(function(){
                adjustNavPositionTop();
              },200)
            }
          }
        });


        //////////////////////////////////////////////////////////////////////////////////
        //COOKIE
        //////////////////////////////////////////////////////////////////////////////////
        function setCookie(name, value, days) {
          var expires = "";
          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Set expiration time
            expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/"; // Set the cookie
        }
        function getCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';'); // Split all cookies by ';'
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length); // Remove leading spaces
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length); // Return cookie value
          }
          return null; // Return null if the cookie is not found
        }
        function deleteCookie(name) {
          document.cookie = name + '=; Max-Age=-99999999; path=/'; // Expire the cookie by setting a negative Max-Age
        }









        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });

        //DETECT SELECT VALUE CHANGE
        $(document).on('change','.ginput_container select', function(e){
          const obj = $(e.target);
          const val = obj.val();
          const pseudoelm = obj.next().find('a.chosen-single > span');
          if(val.length > 0){ //empty
            pseudoelm.addClass('chosen');
          }else{
            pseudoelm.removeClass('chosen');
          }
        })

        $(document).on('change','select.gfield_select', function(e){
          const obj = $(e.target);
          const val = obj.val();
          if(val == ''){
            obj.removeClass('active');
          }else{
            obj.addClass('active');
          }
        })

      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);



  // Accordion Position Scroll
  $(document).on('tap click','.js-accordion-button',function(e){
    const obj = $(this);
    const viewport_width = window.innerWidth;
    if(viewport_width < 992){
      const extra_space = $('.page-nav-scrolled').height() + 60;    
      setTimeout(function(){
        const scrtop = obj.closest('.accordion-item').offset().top;
        console.log(viewport_width);
        $('html, body').scrollTop((scrtop - extra_space));
      },500)
    }
  })

  

})(jQuery); // Fully reference jQuery after this point.

window.addEventListener('load', function() {
  autosize(document.querySelectorAll('.js-header-search-input'));
})




////////////////////////////////////////////////////////////////////////////////////
// SLIDER
////////////////////////////////////////////////////////////////////////////////////
var cellSliding = false;
jQuery(document).ready(function($){
  const cell_cols = 3;
  const nouslide = $('.js-nouslide-carousel');
  const cells = nouslide.find('.nouslide-carousel-cell');
  const active_slide = cells.has('active');
  const container_width = $('.nouslide-viewport').outerWidth();
  const viewset = getWidthSetting();
  let running_pos = 0;
  const locked = (cells.length <= cell_cols)? true: false;
  if(locked){
      nouslide.addClass('locked');
  }

  // Provide initial position to each cell
  cells.each(function(i, cell) {
      $(cell).attr('inst',i);
      if($(cell).prev().length > 0){ // first item
          $(cell).css('left', running_pos+'px');
          running_pos = running_pos + viewset['inactive'];
      }else{
          $(cell).css('left', 0);
          running_pos = running_pos + viewset['active'];
      }
  })

  //Move the last cell to the first position in case the user's first action is to click the previous button.
  if(!locked){
      setTimeout(() => {
          nouslide.prepend(
              nouslide.children().last().css('left', viewset['inactive'] * -1+'px')
          );
      }, 400);
  }
  setTimeout(function(){
    slideAdjustHeight(true);
    slideAdjustWidth();
    jQuery('.section-flexi-testimonials-slider-block').removeClass('invisible');
  },500);


  let resizeTimeout;
  let curleft = null;
  jQuery(window).resize(function() {
    clearTimeout(resizeTimeout); // Clear the previous timeout
    resizeTimeout = setTimeout(function() {
      //slideAdjustHeight();
      slideAdjustWidth();
    }, 200); // Execute after 200ms of no resize activity
  });



  // SWIPE ///////////////////////////////////////
  const carousel = $('.js-nouslide-carousel');
  let startX = 0;  // Starting position for swipe
  let endX = 0;    // Ending position for swipe
  const itemWidth = carousel.find('.nouslide-carousel-cell').outerWidth(true); // Width of a carousel item including margin

  // For touch events (for mobile devices)
  nouslide.on('touchstart', function(event) {
      startX = event.originalEvent.touches[0].pageX; // Get the starting touch position
      console.log('startX:'+startX);
  });

  nouslide.on('touchmove', function(event) {
      endX = event.originalEvent.touches[0].pageX; // Get the current touch position
      console.log('endX:'+endX);
  });

  nouslide.on('touchend', function() {
      if (startX > endX) {
        console.log(startX - endX);
        if((startX - endX) > 60) {
          slideNavigate(jQuery('.nouslide-btn.next'),1,'next');
        }
      } else if (startX < endX) {
          console.log(endX - startX);
          if((endX - startX) > 60) {
            slideNavigate(jQuery('.nouslide-btn.prev'),1,'prev');
          }
      }
  });

  // For mouse events (for desktop)
  let isMouseDown = false;

  nouslide.on('mousedown', function(event) {
      isMouseDown = true;
      startX = event.pageX;  // Capture starting mouse position
  });

  nouslide.on('mousemove', function(event) {
      if (!isMouseDown) return;  // Only detect movement while mouse is down
      endX = event.pageX;  // Capture the new mouse position
  });

  nouslide.on('mouseup', function() {
      if (isMouseDown) {
          if (startX > endX) {
            console.log(startX - endX);
            if((startX - endX) > 60) {
              slideNavigate(jQuery('.js-nouslide-btn.next'),1,'next');
            }
          } else if (startX < endX) {
            console.log(endX - startX);
            if((endX - startX) > 60) {
              slideNavigate(jQuery('.js-nouslide-btn.prev'),1,'prev');
            }
          }
      }
      isMouseDown = false;  // Reset the mouse down flag
  });

  jQuery(document).on('click tap','.js-nouslide-btn',function(e){
      const obj = jQuery(this);
      if(!obj.siblings('.js-nouslide-carousel').hasClass('locked')){
          if(obj.hasClass('next')){ //next
              if(cellSliding == false){
                slideNavigate(obj,1,'next');
              }
          }else{
              if(cellSliding == false){
                slideNavigate(obj,1,'prev');
              }
          }
      }
  })




  function slideAdjustHeight(init = false){
    const nouslide = $('.js-nouslide-carousel');
    const cells = nouslide.find('.nouslide-carousel-cell');
    let running_hgt = 0;
    cells.each(function(i, cell) {
      const obj = jQuery(cell);
      const current_hgt = obj.find('.nouslide-carousel-cell-content').outerHeight(true);
      if(current_hgt > running_hgt){
        if(!obj.hasClass('active') && !init){
            running_hgt = current_hgt;
        }
      }
    })
    cells.height(running_hgt);
    nouslide.height(running_hgt);
  }

  function slideAdjustWidth(){
    curleft = null;
      const ctnr_width = $('.nouslide-viewport').outerWidth();
      const container_width = jQuery('.nouslide-viewport').outerWidth();
      const viewset = getWidthSetting();
      nouslide.find('.nouslide-carousel-cell').find('.nouslide-carousel-cell-content').removeAttr('style');
      nouslide.find('.nouslide-carousel-cell').each(function(i, cell) {
        const obj = $(cell);
        const cell_inst = obj.attr('inst');
        let prev_elm = $(cell).prev();
        if(i == 0){
          curleft = viewset['inactive'] * -1;
        }else{
            if(prev_elm.hasClass("active1")){
              curleft = curleft + viewset['active'];
            }else{
              curleft = curleft + viewset['inactive'];
            }
        }
        $(cell).css({'left':curleft+'px'})
      });

    const viewportWidth = $(window).width();
    if(viewportWidth < 768){
      cells.addClass('active_temp');
    }else{
      cells.removeClass('active_temp');
    }

  }

  function slideNavigate(obj,inst,typ){
      cellSliding = true;
      const nouslide = obj.siblings('.js-nouslide-carousel');
      const viewport = obj.closest('.nouslide-viewport');
      const cells = viewport.find('.nouslide-carousel-cell');
      const curcell = viewport.find('.nouslide-carousel-cell.active'+inst);
      const cell_count = parseInt(cells.length) - 1;
      const idx = curcell.index();

      const viewset = getWidthSetting();

      const active_cell = obj.siblings('.js-nouslide-carousel').find('.nouslide-carousel-cell.active1');

      if(typ=='next'){ //next

          //const current_width = active_cell.find('.nouslide-carousel-cell-content').outerWidth();
          //active_cell.find('.nouslide-carousel-cell-content').removeAttr('style');
          //active_cell.next().find('.nouslide-carousel-cell-content').css({'width':current_width+'px'})
          

          // reposition first slide to last
          let totalWidth = 0;
          jQuery(cells).each(function(i,obj) {
              const cel_width = jQuery(this).outerWidth(true);
              totalWidth += cel_width;
          });

          const newLeftPos = totalWidth - viewset['inactive'];

          nouslide.append (
              nouslide.children().first().css('left', newLeftPos).removeClass('expand')
          );

          // slide all slides to the left
          cells.each(function(i, cell) {
              let movement_width = viewset['inactive'];
              if(jQuery(cell).hasClass('active1')){
                  movement_width = viewset['inactive'];
              }else{
                  if(jQuery(cell).prev().hasClass('active1')){
                      movement_width = viewset['active'];
                  }else{
                      movement_width = viewset['inactive'];
                  }
              }
              var currentLeft = parseInt(jQuery(cell).css('left'), 10);
              var newLeft = currentLeft - movement_width;
              jQuery(cell).css('left', newLeft + 'px');
          })

            curcell.removeClass('active'+inst+ '');
            if(cell_count == idx){
                curcell.siblings().first().addClass('active'+inst)
                setTimeout(function(){
                  curcell.siblings().first().addClass('expand')
                  cellSliding = false;
                },500)
            }else{
                curcell.next().addClass('active'+inst+' expand');
                setTimeout(function(){
                  cellSliding = false;
                },500)
            }


      }else{ //previous

          //const current_width = active_cell.find('.nouslide-carousel-cell-content').outerWidth();
          //active_cell.find('.nouslide-carousel-cell-content').removeAttr('style');
          //active_cell.prev().find('.nouslide-carousel-cell-content').css({'width':current_width+'px'})


          cells.each(function(i, cell) {
              let movement_width = viewset['inactive'];
              if(jQuery(cell).hasClass('active1')){
                  movement_width = viewset['active'];
              }else{
                  movement_width = viewset['inactive'];
              }
              var currentLeft = parseInt(jQuery(cell).css('left'), 10);
              var newLeft = currentLeft + movement_width;
              jQuery(cell).css('left', newLeft + 'px');
          })

          curcell.removeClass('active'+inst+ ' expand');
          if(0 == idx){
              curcell.siblings().last().addClass('active'+inst+' expand')
          }else{
              curcell.prev().addClass('active'+inst+' expand');
          }


          setTimeout(() => {
              nouslide.prepend(
                  nouslide.children().last().css('left', viewset['inactive'] * -1+'px').addClass('expand')
              );
              cellSliding = false;
          }, 500);
      }
  }

  function getWidthSetting(){
    const ctnr_width = jQuery('.nouslide-viewport').outerWidth();
    const viewportWidth = jQuery(window).width();
    let active_width = ctnr_width * .5;
    let inactive_width = ctnr_width * .25;
    if(viewportWidth < 992){
      inactive_width = ctnr_width * .5;
    }
    if(viewportWidth < 768){
      active_width = ctnr_width;
      inactive_width = ctnr_width;
    }
    let vparr = {"active":active_width, "inactive":inactive_width};
    return vparr;
  }

});


//////////////////////////////////////////////////////////////////////////////////
//SINGLE CENTRE MAP
//////////////////////////////////////////////////////////////////////////////////
window.onload = function() {
  if(jQuery('body').hasClass('single-centres')){
    singleCentreGoogleMaps();
  }
};

function singleCentreGoogleMaps() {
  if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
    // Google Maps API is loaded, initialise the map
    initCentreMap();
  } else {
    // Google Maps API is not loaded, retry after a delay
    // Retry every second to check if the Google Maps API is loaded
    // console.error('Google Maps API is not loaded, retrying...');
    setTimeout(singleCentreGoogleMaps, 1000);
  }
}


function initCentreMap() {
  const target = jQuery('#single-centre-map');
  const lat = target.attr('data-lat');
  const lng = target.attr('data-lng');
  const icon = target.attr('data-icon');
  const title = target.attr('data-title');
  const address = target.attr('data-address');

  var location = { lat: parseFloat(lat), lng: parseFloat(lng) };
  var customMapStyle = [{"stylers":[{"hue":"#2c3e50"},{"saturation":250}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":50},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]}];

  var map = new google.maps.Map(document.getElementById('single-centre-map'), {
      zoom: 6,
      center: location,
      styles: customMapStyle,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      scaleControl: false,
      rotateControl: false,
      zoomControl: true,
  });
  var customMarker = {
      url: icon,
      size: new google.maps.Size(50, 50),
      scaledSize: new google.maps.Size(50, 50),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 25)
  };
  var marker = new google.maps.Marker({
      position: location,
      map: map,
      title: title,
      icon: customMarker
  });
  var infoWindow = new google.maps.InfoWindow({
      content: '<h4>'+title+'</h4><p>'+address+'</p>'
  });
  marker.addListener('click', function() {
      infoWindow.open(map, marker);
  });
}



//////////////////////////////////////////////////////////////////////////////////
//Job Adder entire card clickable
//////////////////////////////////////////////////////////////////////////////////
jQuery(function ($) {
  $(document).on('click', '.ja-job-list-container .job', function (e) {
    // Ignore actual interactive elements
    if ($(e.target).closest('a, button, input').length) {
      return;
    }
    // Trigger JobAdder's existing JS click
    $(this).find('.title a').trigger('click');
  });
});